import React from "react";

export default function Header() {
  return (
    <header>
      <img
        src="http://www.pngall.com/wp-content/uploads/2016/05/Trollface.png"
        alt="Troll Face"
      />
      <p>Meme Generator</p>
    </header>
  );
}
